
const moment = require('moment')
const dayjs = require('dayjs')
const duration = require('dayjs/plugin/duration')

dayjs.extend(duration)

/**
 * @desc 比较 最后一个阶梯的结束时间 和 合同的结束时间 大小
 * @param {Array} stairConfig 阶梯配置
 * @param {String} startTime 开始时间
 * @param {String} endTime 结束时间
 * @returns {Boolean}
 */
function diffDate(stairConfig, startTime, endTime) {
  const dayEndTime = dayjs(endTime).format('YYYY-MM-DD')
  const { feePiecewiseConfigList } = stairConfig.feePiecewiseCalculation
  const lastStairEndMonth = feePiecewiseConfigList[feePiecewiseConfigList.length - 1].endMonth
  const stairEndDate = dayjs(startTime).add(lastStairEndMonth, 'months').subtract(1, 'day').format('YYYY-MM-DD')
  const difference = dayjs(stairEndDate).diff(dayEndTime, 'day')
  // 如果合同周期的结束时间大于阶梯的结束时间，提示报错
  if (difference >= 0) {
    return false
  } else {
    return true
  }
}

/**
 * @desc 计算固定周期的实际总天数
 * @param {String} startTime 开始时间
 * @param {String} type 付/收款方式
 * @param {Number} dailyRule 代表日租金规则，0：按照开始月自然天数 1：按照30天
 * @returns {Number}
 */
function collectDay(startTime, type, dailyRule) {
  let endTime = ''
  let days = ''
  if (type === 'month' || type === 'monthN') {
    days = dailyRule ? 30 : moment(startTime).daysInMonth()
    return days
  } else if (type === 'week') {
    endTime = moment(startTime).add(7, 'days').format('YYYY-MM-DD')
  } else if (type === 'thirty') {
    endTime = moment(startTime).add(30, 'days').format('YYYY-MM-DD')
  } else if (type === 'threeMonth') {
    endTime = moment(startTime).add(3, 'months').format('YYYY-MM-DD')
  } else if (type === 'halfYear') {
    endTime = moment(startTime).add(6, 'months').format('YYYY-MM-DD')
  } else if (type === 'year') {
    endTime = moment(startTime).add(1, 'years').format('YYYY-MM-DD')
  }
  days = moment(endTime).diff(moment(startTime), 'days')
  return days
}

/**
 * @desc 判断开始月份和结束月份哪个月份天数时间小，返回天数时间小的月份总天数和月份标识
 * @param {String} startTime 开始时间
 * @param {String} endTime 结束时间
 * @returns {lessDays-两个月份中包含更少天数的月总天数, lessDaysMonth-天数较少的 st:开始时间；et:结束时间；equal: 一样}
 */
function judgeSomeMonthMore(startTime, endTime) {
  let lessDays = ''
  let lessDaysMonth = ''
  const std = moment(startTime).daysInMonth()
  const etd = moment(endTime).daysInMonth()
  if (std > etd) {
    lessDays = etd
    lessDaysMonth = 'et'
  } else if (std < etd) {
    lessDays = std
    lessDaysMonth = 'st'
  } else {
    lessDays = std
    lessDaysMonth = 'equal'
  }
  return {
    lessDays,
    lessDaysMonth,
  }
}

/**
 * @desc 判断首尾月相加是否为整月
 * @param {String} startTime 开始时间
 * @param {String} endTime 结束时间
 * @returns {Boolean}
 */
function checkIsWholeMonth(startTime, endTime) {
  const d = new Date(startTime).getDate() // 获取开始时间的日
  const endAddOne = moment(endTime).add(1, 'days').format('YYYY-MM-DD')
  const fCycle = moment(endAddOne).diff(moment(startTime), 'months') // 开始时间和结束时间是否够一个月
  const someOneDay = moment(startTime).add(fCycle, 'months').format('YYYY-MM-DD')
  const extraDOrM = moment(endAddOne).diff(someOneDay, 'days') // 剩余天数
  if (fCycle === 0) { // 不够一个月，首尾月加起来肯定不是整月
    return false
  } else {
    // 够一个整月的前提下，看下剩余天数有多少天，如果是0天且开始时间的那天不是1号，说明是整月
    if (extraDOrM === 0 && d !== 1) {
      return true
    } else {
      return false
    }
  }
}

/**
 * @desc 计算一个固定时间段有几个月、剩余天数、
 * @param {String} st 开始时间
 * @param {String} ent 结束时间
 * @returns {Object} totalMonth-包含几个整月，remainDays-剩余天数, lastPeriodTotalDays-最后一个满月的自然月有多少天
 */
function monthAndRemainDays(st, ent) {
  const startDate = dayjs(st).format('YYYY-MM-DD')
  const endDate = dayjs(ent).format('YYYY-MM-DD')

  let totalMonth = 0
  let remainDays = 0
  let lastPeriodTotalDays = 0

  const dateGather = [{
    startDate,
    endDate: dayjs(startDate).add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD'),
  }]

  let enableStop = true
  let i = 0

  while (enableStop) {
    lastEndDate = dateGather[dateGather.length - 1].endDate
    // 按照满月循环出的最后一个周期的结束时间如果在传入的结束时间后面，或者是 两个时间相等，就停止循环
    if (dayjs(endDate).isBefore(dayjs(lastEndDate)) || endDate === lastEndDate) {
      enableStop = false
    } else {
      const currentStartDate = dayjs(dateGather[i].endDate).add(1, 'day').format('YYYY-MM-DD')
      const currentEndDate = dayjs(currentStartDate).add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD')
      const dateObj = {
        startDate: currentStartDate,
        endDate: currentEndDate,
      }
      dateGather.push(dateObj)
    }
    i++
  }

  // 如果传入的开始时间和传入的结束时间相等，这时候月份数量为0，天数为一天
  if (startDate === endDate) {
    return {
      totalMonth: 0,
      remainDays: 1,
      lastPeriodTotalDays: dayjs(startDate).daysInMonth(),
    }
  }
  // 如果最后一个周期的结束时间和传入的结束时间一致，说明剩余天数为0
  if (dateGather[dateGather.length - 1].endDate === endDate) {
    totalMonth = dateGather.length
    const lstSt = dateGather[dateGather.length - 1].startDate
    lastPeriodTotalDays = dayjs(lstSt).daysInMonth()
  // 如果周期只有一个
  } else if (dateGather.length === 1) {
    totalMonth = 0
    remainDays = dayjs(endDate).diff(dateGather[0].startDate, 'day') + 1
    lastPeriodTotalDays = dayjs(dateGather[0].startDate).daysInMonth()
  } else {
    totalMonth = dateGather.length - 1
    const lstSt = dateGather[dateGather.length - 1].startDate
    remainDays = dayjs(endDate).diff(dayjs(lstSt), 'day') + 1
    lastPeriodTotalDays = dayjs(lstSt).daysInMonth()
  }
  return {
    totalMonth,
    remainDays,
    lastPeriodTotalDays,
  }
}

/**
 * @desc 费用格式化- string转number
 * @param {Array} resultArr 周期详情数据
 */
function formatNumber(resultArr = []) {
  resultArr.forEach((item) => {
    item.planAmount = Number(item.planAmount)
  })
}
module.exports = {
  collectDay,
  judgeSomeMonthMore,
  checkIsWholeMonth,
  formatNumber,
  monthAndRemainDays,
  diffDate,
}
